setTimeout(function () {
    const videos = document.querySelectorAll(".vw-product-widget video");
  
    function playVwMedia() {
      videos.forEach((video) => {
        video.play().catch((error) => {
          console.error(error);
        });
      });
    }
    playVwMedia();
    const variants = document.querySelectorAll(".option__color");
    variants.forEach((variant) => {
      variant.addEventListener("click", function () {
        setTimeout(function () {
          console.log('aici')
          playVwMedia();
        }, 500);
      });
    });
  }, 800);
  